import type {DateTimeModel} from '../../core/domain/Date/DateTime.model';
import type {Period} from './types';

export const getStartDateOfPeriod = ({
  endDate,
  period,
}: {
  endDate: DateTimeModel;
  period: Period;
}) => {
  const convertors: Record<Period, (date: DateTimeModel) => DateTimeModel> = {
    'half-year': date => date.subtract(6, 'month'),
    month: date => date.subtract(1, 'month'),
    week: date => date.subtract(7, 'day'),
    year: date => date.subtract(1, 'year'),
  };

  return convertors[period](endDate);
};
